const ufeApi = require('services/api/ufeApi');
const cookieUtils = require('utils/Cookies');

// https://confluence.sephora.com/wiki/display/ILLUMINATE/WIP+-+GET+Same+Day+User+Specific+Product+Details+API

function getSameDaySpecificProductDetails(profileId = 'current', productId, skuId = null) {
    let url = `/api/users/profiles/${profileId}/samedayproduct/${productId}`;

    if (cookieUtils.isBXSProductEnabled()) {
        url = `/api/v3/users/profiles/${profileId}/samedayproduct/${productId}`;
    }

    const queryParams = [];

    if (skuId !== null) {
        queryParams.push(`?preferedSku=${skuId}`);
    }

    url = url + queryParams.join('&');

    return ufeApi.makeRequest(url, { method: 'GET' }).then(data => (data.errorCode ? Promise.reject(data) : data));
}

module.exports = getSameDaySpecificProductDetails;
